module.exports = __webpack_public_path__ + "static/media/certificate.03649bac.pdf";